(function (app) {

    app.directive("ssnInput",
        [
            "$filter", function ($filter) {
                var ssnFilter = $filter("ssn");
                var ssnReverseFilter = $filter("ssnReverse");
                return {
                    require: "ngModel",
                    scope: {
                    },
                    restrict: "A",
                    link: function (scope, element, attrs, ngModelCtrl) {
                        var formatter = function (value) {
                            return ssnFilter(value);
                        };
                        var parser = function (value) {
                            var caretPosition = element[0].selectionStart;
                            var formatted = ssnReverseFilter(value);
                            element.val(ssnFilter(formatted));

                            if (element.val().charAt(element.val().length - 1) === "-")
                                element[0].selectionStart = element[0].selectionEnd = caretPosition + 1;
                            else
                                element[0].selectionStart = element[0].selectionEnd = caretPosition;

                            return formatted;
                        }

                        ngModelCtrl.$formatters.push(formatter);
                        ngModelCtrl.$parsers.unshift(parser);
                    }
                }
            }
        ]);

})(window.app); //jshint ignore:line